module.exports = __webpack_public_path__ + "static/media/gryphon_musee_hero_join.af658870.jpg";